import * as IoC from 'typescript-ioc';
import { JobType } from '../../../../api/jobs.dao';
import { JobConfiguration } from '../../job-configuration';
import { IAttendeesDAO } from '../../../../api/attendees.dao';

export class AttendeesUpdateBulkJob extends JobConfiguration {
    public readonly type = JobType.AttendeeUpdateBulk;
    public readonly name = 'Bulk Update Attendees';
    public readonly description = 'Attendee Status';

    public async execute(execParams) {
        return IoC.Container.get(IAttendeesDAO).attendeeBulkUpdate(execParams);
    }
}

export default {
    [JobType.AttendeeUpdateBulk]: AttendeesUpdateBulkJob
};
